// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__dhl+T","inputName":"ContactForm_inputName__a8jFO","inputNumber":"ContactForm_inputNumber__DBiVZ"};